var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"id":"file-input","accept":"image/png, image/jpeg","type":"file","multiple":""},on:{"change":function($event){return _vm.handleFileUpload()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }